module.exports = __webpack_public_path__ + "static/img/Comscore-Selected.74b1438.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/fileTypes/Comscore-Selected.png
// module id = 753
// module chunks = 0